import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../../services/exports/Constants';

export default {
  title: {
    [ORDER_METHODS.DELIVERY]: 'Levering',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Roomservice',
      [RoomServiceLocationType.TableService]: 'Bordservice',
    },
  },
  form: {
    doorbell_name: {
      placeholder: 'Navn på dørklokke (valgfrit)',
    },
    company_name: {
      placeholder: 'Firmanavn (valgfrit)',
    },
    customer_note: {
      placeholder: 'Leveringsinstruktioner (valgfrit)',
    },
    order_instructions: {
      placeholder: 'Skriv ordreinstruktioner...',
    },
  },
};
